import { PlanFieldType } from '@/modules/Renewals/RenewalSetup/PlanYearPlansStep/PlansSummaryContainer/hooks/usePlanCodeActions';
import { baseStoreCreator } from '@/utils/store';

export interface EditablePlan {
  id: string;
  planCode: string;
  planName: string;
  defaultPlanCode: string;
  defaultPlanName: string;
}

export type ErrorsMap = Record<string, Partial<Record<PlanFieldType, string[]>>>;

export interface PlansPayload {
  plans: EditablePlan[];
  errors: ErrorsMap;
}

export const DEFAULT_VALUES: PlansPayload = {
  plans: [],
  errors: {},
};

export const usePlansStore = baseStoreCreator<PlansPayload>(DEFAULT_VALUES);

export default usePlansStore;
